import React from 'react';
import '../css/FreeHomeDelivery.css';
import Review from './review';
const features = [
  {
    icon: "🚚",
    title: "Convenient Doorstep Delivery",
    description: "Get your prescriptions and health essentials delivered right to your home—no extra cost, no hassle."
  },
  {
    icon: "⏱️",
    title: "Save Time & Effort",
    description: "Skip the pharmacy lines and let us handle the logistics. Perfect for busy schedules, mobility challenges, or anyone who values convenience."
  },
  {
    icon: "💸",
    title: "Free & Cost-Effective",
    description: "Enjoy free delivery with no hidden fees. We help you save on travel and parking costs."
  },
  {
    icon: "📦",
    title: "Easy Tracking & Management",
    description: "Order online or by phone, track your deliveries, and manage refills with ease."
  }
];

function FreeHomeDelivery() {
  return (
    <div className="delivery-page">
      <div className="delivery-banner">
        <img
          src={'/img_1.png'}
          alt="Free Home Delivery Banner"
          className="delivery-banner-img"
        />
        <div className="delivery-banner-overlay"></div>
        <div className="delivery-banner-content">
          <h1>Free Home Delivery</h1>
        </div>
      </div>

      <header className="delivery-header">
        <h2>Bringing Health to Your Doorstep</h2>
        <p>
          Quality Pharmacy makes getting your medications and health products easier than ever. Our free home delivery service is designed for your convenience, safety, and peace of mind.
        </p>
      </header>

      <div className="delivery-features">
        {features.map((feature, idx) => (
          <div className="delivery-feature-card" key={idx}>
            <div className="delivery-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>

      <div className="delivery-benefits-card">
        <h4>How It Works</h4>
        <ul>
          <li>
            <strong>Step 1:</strong> Place your order online or by phone. Have your prescription ready.
          </li>
          <li>
            <strong>Step 2:</strong> We verify your prescription and prepare your order.
          </li>
          <li>
            <strong>Step 3:</strong> Your medications and health products are delivered safely to your home.
          </li>
        </ul>
        <h4>Why Choose Home Delivery?</h4>
        <ul>
          <li><strong>Convenience:</strong> No need to leave home—perfect for busy families, seniors, or anyone with mobility concerns.</li>
          <li><strong>Reliability:</strong> Timely, secure, and professional delivery every time.</li>
          <li><strong>Support:</strong> Our team is here to answer questions and help you manage refills.</li>
        </ul>
      </div>

     {/**  <aside className="delivery-sidebar">
        <h3>Other Services</h3>
        <ul>
          <li><a className='none' href="/services/cbd-products">CBD Products</a></li>
          <li><a className='none' href="/services/free-home-delivery">Free Home Delivery</a></li>
          <li><a className='none' href="#">Patient Consultation</a></li>
          <li><a className='none' href="/services/health-product">Health Products</a></li>
          <li><a className='none' href="/refills">Refills Made Easy</a></li>
        </ul>
      </aside>
      */}
       <Review/>
    </div>
  );
}

export default FreeHomeDelivery;